import StoredLayout from '../../layouts/StoredLayout'
import IconWidgets from './IconWidgets'
export default StoredLayout(IconWidgets)



// WEBPACK FOOTER //
// ./src/widgets/icon-widgets/index.js